import { inject, Injectable } from '@angular/core';
import { injectDispatch } from '@ngrx/signals/events';
import { UserStore } from '../store/user.store';
import { userEvents } from '@kikkz/shared/user/util';

@Injectable()
export class UserFacade {
  private readonly store = inject(UserStore);
  private readonly dispatch = injectDispatch(userEvents);

  readonly user = this.store.user;
  readonly isLoggedIn = this.store.isLoggedIn;
  readonly username = this.store.username;

  clearUser(): void {
    this.dispatch.clearUser();
  }
}
